import React, { useEffect, useRef } from 'react';
import './SinoTokenBackground.css';

const THREE_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r134/three.min.js';
const VANTA_GLOBE_SRC = 'https://cdn.jsdelivr.net/npm/vanta/dist/vanta.globe.min.js';

let threeScriptPromise;
let vantaScriptPromise;

function appendScript(src) {
  return new Promise((resolve, reject) => {
    const existing = [...document.scripts].find((script) => script.src === src);
    if (existing) {
      if (existing.dataset.loaded === 'true') {
        resolve();
        return;
      }
      existing.addEventListener('load', resolve, { once: true });
      existing.addEventListener('error', reject, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = () => {
      script.dataset.loaded = 'true';
      resolve();
    };
    script.onerror = reject;
    document.body.appendChild(script);
  });
}

function loadVantaGlobe() {
  threeScriptPromise = threeScriptPromise || appendScript(THREE_SRC);
  vantaScriptPromise = vantaScriptPromise || threeScriptPromise.then(() => appendScript(VANTA_GLOBE_SRC));
  return vantaScriptPromise;
}

const SinoTokenBackground = () => {
  const vantaRef = useRef(null);

  useEffect(() => {
    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      return undefined;
    }

    let effect = null;
    let cancelled = false;

    loadVantaGlobe()
      .then(() => {
        if (cancelled || !vantaRef.current || !window.VANTA?.GLOBE) {
          return;
        }

        effect = window.VANTA.GLOBE({
          el: vantaRef.current,
          THREE: window.THREE,
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          minHeight: 200,
          minWidth: 200,
          scale: 1,
          scaleMobile: 1,
          color: 0x2563eb,
          color2: 0x93c5fd,
          backgroundColor: 0xffffff,
          size: 1,
        });
      })
      .catch(() => {});

    return () => {
      cancelled = true;
      if (effect?.destroy) {
        effect.destroy();
      }
    };
  }, []);

  return (
    <div className='sino-token-background' aria-hidden='true'>
      <div className='sino-token-dot-field' />
      <div className='sino-token-orbit sino-token-orbit-large' />
      <div className='sino-token-orbit sino-token-orbit-small' />
      <div className='sino-token-vanta-box homeBg-box' ref={vantaRef} />
    </div>
  );
};

export default SinoTokenBackground;
